import { getBagSummary, subscribeToUpdates } from "@src/client/sdk/bag";

import subscribeToUpdatesCallback from "./subscribeToUpdatesCallback";
import validPath from "./validPath";

const infoBannerMiddleware = ({ getState, dispatch }) => {
  if (validPath()) {
    getBagSummary().then(({ totalQuantity: oldQuantity }) => {
      subscribeToUpdates(
        subscribeToUpdatesCallback({ oldQuantity, dispatch, state: getState() })
      );
    });
  }

  return next => async action => {
    next(action);
  };
};

export default infoBannerMiddleware;
